import React from 'react'

const Loading = () => {
  return (
    <>
    <div className="fixed  z-50 inset-0 flex justify-center items-center bg-black bg-opacity-35">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-primary"></div>
  </div>
  </>
  )
}

export default Loading